// services/purchases/CreditNoteService.ts
import { creditNoteApi } from '../../api';

const CreditNoteService = {
  addProduct: async (
    product
  ) => {
    const response = await creditNoteApi.add(product);
    return response.data;
  },

  deleteProduct: async (
    detailId: number
  ) => {
    const response = await creditNoteApi.removeCustom(`/${detailId}`);
    return response.data;
  },
};

export default CreditNoteService;
